import React, { useState } from 'react';
import { Toast, InputBox, Input, Label, InputGroup } from '@lana-ui/common';
import { Button } from '@lana-ui/login';
import arg from '@images/Argentina.png';
import '../../Statics/Scss/Form/personal-data.scss';
import { useEffect } from 'react';
import { Formik, Form } from 'formik';
import PersonalDataSchema from '../../Validations/ValidacionPersonalData';
import InputFormik from '../Common/Formik/Input';
import RadioFormik from '../Common/Formik/Radio';
import Text from '../Common/common/src/text/Text';
import { EventTrackAndLogData } from '../../Config/TrackAndLogData';
import Modal from '../Common/common/src/modal/Modal';
import ModalBodyExterior from './ModalBodyExterior';
import Link from '../Common/common/src/link';
import Url from '../../Helpers/Url';
import CheckInputFormik from '../Common/Formik/CheckInputFormik';
import SelectFormik from '../Common/Formik/Select';

const PersonalData = ({ state, send }) => {
    const [showToast, setShowToast] = useState(false);
    const [showToastDNI, setShowToastDNI] = useState(false);
    const [formData, setFormData] = useState(state.context.datosPersonales);
    const [residencia, setResidencia] = useState(formData.residencia ? formData.residencia : 'Argentina');
    const [formErrors, setFormErrors] = useState(null);
    const [modal, setModal] = useState(false);
    // const [disabledDocumentInput, setDisabledDocumentInput] = useState(true);
    // const [typeDocumentSelected, setTypeDocumentSelected] = useState(formData?.tipoDocumento ? formData?.tipoDocumento : "");
    const mailOcultoDniExistente = state.context.datosPersonales.mailOfuscado;
    const planCampaniaInformaDomicilio = state.context?.planCampania.planes[0].informaDomicilio;
    useEffect(() => {
        setShowToast(state.context.showToastPersonalData);
        updateValueTermsCheckboxWithError(state.context.showToastPersonalData);
    }, [state.context.showToastPersonalData]);

    useEffect(() => {
        setShowToastDNI(state.context.showToastDniInvalido);
        updateValueTermsCheckboxWithError(state.context.showToastDniInvalido);
    }, [state.context.showToastDniInvalido]);

    useEffect(() => {
        send('INPUTSPARCIALES', {
            datosPersonales: { ...formData },
            erroresDatosPersonales: { ...formErrors },
        });
    }, [formData, formErrors]);

    const trackingFormikErrors = (errors) => {
        if (errors) {
            setFormErrors(errors);
            for (const name in errors) {
                EventTrackAndLogData('error-form', name + ' - ' + errors[name]);
            }
        }
    };

    const handleChange = ({ target }, errors) => {
        target.name === 'residencia' && setResidencia(target.value);
        target.name === 'residencia' && target.value === 'Exterior' && planCampaniaInformaDomicilio && setModal(true);
        setFormData({
            ...formData,
            [target.name]: target.name === 'terminos' ? target.checked : target.value,
        });

        /*  
            Tracking errors for Analytics (only "nombre", "apellido", "numeroDocumento")
            https://docs.google.com/spreadsheets/d/1JPWpPRturk47NrK_p1WscAU5SlLbCq4dlUaTcubn9Lk/edit#gid=0
        */
        if (errors) {
            setFormErrors(errors);
        }
    };

    // const handleChangeTipoDNI = (e) => {
    //     const value = e.target.value;
    //     value !== '' ? setDisabledDocumentInput(false) : setDisabledDocumentInput(true);
    //     setTypeDocumentSelected(value);
    // };

    const handleSubmit = (e) => {
        formData.residencia = residencia;
        formData.tipoDocumento = 'DNI';
        // formData.tipoDocumento = typeDocumentSelected;

        if (formData.residencia && formData.terminos) {
            formData.nombre = formData.nombre.trimEnd();
            formData.apellido = formData.apellido.trimEnd();
            const contexto = { ...formData, telefonoCelular: formData.residencia == 'Exterior' ? '1234567890' : formData.telefonoCelular };
            send('CONTINUAR', {
                enabledDomicilio: formData.residencia == 'Argentina',
                datosPersonales: contexto,
            });
        }
    };

    const closeModal = () => {
        setModal(false);
    };

    const updateValueTermsCheckboxWithError = (personalDataHasError) => {
        if (personalDataHasError) {
            setFormData({ ...formData, terminos: false });
        }
    };
    return (
        <Formik
            initialValues={{
                nombre: formData?.nombre,
                apellido: formData?.apellido,
                numeroDocumento: formData?.numeroDocumento,
                telefonoCelular: formData?.residencia === 'Exterior' ? '1234567890' : formData?.telefonoCelular,
                terminos: formData?.terminos === '' ? false : formData?.terminos,
                // tipoDeDocumento: "typeDocumentSelected",
            }}
            enableReinitialize
            validationSchema={PersonalDataSchema}
            onSubmit={handleSubmit}
        >
            {({ errors }) => (
                <Form className="personal-data-form">
                    {formData.residencia === 'Exterior' && modal && <Modal closeModal={closeModal} children={<ModalBodyExterior onAccept={closeModal} />} />}

                    <div className="suscriptionProcess-container --mb-16">
                        <InputGroup className="--mb-0 suscriptionProcess-container__items">
                            <Label text={'Nombre'} />
                            <InputFormik
                                className="suscriptionProcess-container__items__input"
                                type="text"
                                inputmode="text"
                                name="nombre"
                                aria-label="Ingrese su nombre"
                                onChange={(event) => handleChange(event, errors)}
                                value={formData?.nombre}
                                tabindex="0"
                            />
                        </InputGroup>
                        <InputGroup className="--mb-0 suscriptionProcess-container__items">
                            <Label text={'Apellido'} />
                            <InputFormik
                                className="suscriptionProcess-container__items__input"
                                type="text"
                                inputmode="text"
                                name="apellido"
                                aria-label="Ingrese su apellido"
                                onChange={(event) => handleChange(event, errors)}
                                value={formData?.apellido}
                                tabindex="0"
                            />
                        </InputGroup>
                    </div>
                    {/*Se deja comentado por si mas adelante se necesita habilitar DNIs para el exterior tambien*/}
                    {/* <div className="country-input">
                        <InputGroup>
                            <InputGroup>
                                <Label text="Tipo de documento" />
                                <Input className="tipo-doc" placeholder="DNI" type="text" disabled />
                            </InputGroup>
                            <SelectFormik
                                handleChange={handleChangeTipoDNI}
                                name="tipoDeDocumento"
                                disabled={state.context.usuarioPrecargado}
                            >
                                <option value="">Seleccioná una opción</option>
                                <option value="DNI">DNI</option>
                                <option value="EXTER">DNI EXTERIOR</option>
                            </SelectFormik>
                        </InputGroup>

                        <InputGroup>
                            <Label text="Número de documento" />
                            <InputFormik
                                disabled={state.context.usuarioPrecargado}
                                // disabled={state.context.usuarioPrecargado || disabledDocumentInput}
                                type="number"
                                name="numeroDocumento"
                                onChange={(event) => handleChange(event, errors)}
                                value={formData?.numeroDocumento}
                            />
                        </InputGroup>
                    </div> */}

                    <div className="suscriptionProcess-container --mb-16">
                        <InputGroup className="--mb-0 suscriptionProcess-container__items">
                            <Label text={'Tipo de documento'} />
                            <Input type="text" placeholder="DNI" disabled />
                        </InputGroup>
                        <InputGroup className="--mb-0 suscriptionProcess-container__items">
                            <Label text={'N° de documento'} />
                            <InputFormik
                                disabled={state.context.usuarioPrecargado}
                                // disabled={state.context.usuarioPrecargado || disabledDocumentInput}
                                type="number"
                                inputmode="numeric"
                                name="numeroDocumento"
                                onChange={(event) => handleChange(event, errors)}
                                value={formData?.numeroDocumento}
                                tabindex="0"
                            />
                        </InputGroup>
                    </div>

                    {showToast && (
                        <Toast type={'toast'} className="--roboto" status={'warning'} title="¡Ups!" close changeValue={() => setShowToast(false)}>
                            Tu DNI ya se encuentra asociado a la cuenta {mailOcultoDniExistente}
                            <br />
                            <Link href={Url.RedirectToLoginPreserveCallback} className="--font-bold --underline">
                                Ingresá con ese email
                            </Link>{' '}
                            <br />
                            <br /> ¿No es tuyo ese email? Comunicate al 5199-4787 o desde el exterior a <span className="--font-semiBold">accesodigital@lanacion.com.ar</span>
                        </Toast>
                    )}
                    {showToastDNI && (
                        <Toast type={'toast'} className="--roboto" status={'warning'} title="¡Ups!" close changeValue={() => setShowToastDNI(false)}>
                            El DNI ingresado no es válido. <br />
                            Por favor intentá nuevamente
                            <br />
                        </Toast>
                    )}
                    <InputGroup className="--mb-0">
                        <Label text={'Lugar de residencia'} />
                        <div className="country-input">
                            <InputBox
                                name="residencia"
                                input={
                                    <RadioFormik checked={residencia === 'Argentina'} onChange={handleChange} name="residencia" value="Argentina" tabindex="0">
                                        Argentina
                                    </RadioFormik>
                                }
                            />
                            <InputBox
                                name="residencia"
                                input={
                                    <RadioFormik checked={residencia === 'Exterior'} onChange={handleChange} name="residencia" value="Exterior">
                                        Exterior
                                    </RadioFormik>
                                }
                            />
                        </div>
                    </InputGroup>
                    <InputGroup className="phone-group">
                        <Label text={'Teléfono celular'} />
                        <div className="phone-input">
                            <div className="flag">
                                <img width="20px" src={arg} alt="" /> <span className="country-code">+54 9</span>
                            </div>
                            <InputFormik
                                type="number"
                                inputmode="tel"
                                disabled={formData?.residencia === 'Exterior'}
                                name="telefonoCelular"
                                aria-label="Ingrese su número de teléfono celular"
                                onChange={handleChange}
                                value={formData?.telefonoCelular !== '1234567890' && formData.residencia !== 'Exterior' ? formData.telefonoCelular : ''}
                                tabindex="0"
                            />
                        </div>
                    </InputGroup>

                    <Button
                        type="submit"
                        className="--not-disabled"
                        label="Continuar"
                        data-dd-action-name="Guarda Datos Personales"
                        onClick={() => {
                            trackingFormikErrors(errors);
                        }}
                    />

                    <CheckInputFormik
                        className="checkbox --acepta-terminos"
                        name="terminos"
                        children={'Acepto los'}
                        link="términos y condiciones"
                        url="https://www.contacto.lanacion.com.ar/tyc"
                        onChange={(event) => handleChange(event, errors)}
                    />

                </Form>
            )}
        </Formik>
    );
};

export default PersonalData;
